const routes = {
  // Access
  login: '/auth/login',
  forgotPassword: '/auth/forgot-password',
  resetPassword: '/auth/reset-password',

  // Admin
  dashboard: '/',

  contacts: {
    index: '/contacts',
    detail: '/contacts/:id',
    tab: '/contacts/:id/:tab',
  },

  inbox: {
    index: '/inbox',
    detail: '/inbox/:id',
    tab: '/inbox/:id/:tab',
  },

  tasks: {
    index: '/tasks',
    detail: '/tasks/:id',
    tab: '/tasks/:id/:tab',
  },

  purchaseOrders: {
    index: '/purchase-orders',
    detail: '/purchase-orders/:id',
    tab: '/purchase-orders/:id/:tab',
  },

  salesOrders: {
    index: '/sales-orders',
    detail: '/sales-orders/:id',
    tab: '/sales-orders/:id/:tab',
    packingList: {
      detail: '/sales-orders/:id/packing-lists/:listID',
      tab: '/sales-orders/:id/packing-lists/:listID/:tab'
    },
  },

  materials: {
    index: '/materials',
    detail: '/materials/:id',
    tab: '/materials/:id/:tab',
  },

  users: {
    index: '/users',
    detail: '/users/:id',
  },

  management: '/management/:tab?',

  archive: {
    contact: {
      detail: '/archive/contacts/:id',
      tab: '/archive/contacts/:id/:tab',
    },
    purchaseOrder: {
      detail: '/archive/purchase-orders/:id',
      tab: '/archive/purchase-orders/:id/:tab',
    },
    salesOrder: {
      detail: '/archive/sales-orders/:id',
      tab: '/archive/sales-orders/:id/:tab',
      packingList: {
        detail: '/sales-orders/:id/packing-lists/:listID',
        tab: '/sales-orders/:id/packing-lists/:listID/:tab'
      },
    },
    material: {
      detail: '/archive/materials/:id',
      tab: '/archive/materials/:id/:tab',
    },
    task: {
      detail: '/archive/tasks/:id',
      tab: '/archive/tasks/:id/:tab',
    },
    index: '/archive/:tab?'
  }
};

export default routes;
